import { getRequestUrl, Request } from "../../request";
import { getURL } from "../../utils";

export const get_cars = (data) => {
  return Request.get(getRequestUrl(getURL(`/api/corporation-pa/cars/company-cars/`), data));
};

export const export_cars_report = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/cars/company-cars/`), data))
}

export const get_cars_brands = (type) => {
  return Request.get(getURL(`/api/corporation-pa/cars/load-cars-brand/`), {
    type,
  });
};

export const get_cars_models = (brand_id) => {
  return Request.get(getURL(`/api/corporation-pa/cars/load-cars/`), {
    brand_id,
  });
};

export const add_car = (data) => {
  return Request.post(getURL(`/api/corporation-pa/cars/company-cars/`), data);
};

export const edit_car = (data) => {
  return Request.put(getURL(`/api/corporation-pa/cars/company-cars/`), data);
};

export const get_car_services_report = (data) => {
  return Request.get(getURL(`/api/corporation-pa/service-center/bill-customers/`), data);
}

export const export_car_services_report = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/service-center/bill-customers/`), data))
}